import { render, staticRenderFns } from "./CasePicker.vue?vue&type=template&id=4851be86&scoped=true&"
import script from "./CasePicker.vue?vue&type=script&setup=true&lang=js&"
export * from "./CasePicker.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4851be86",
  null
  
)

export default component.exports